import { type ReactNode } from 'react';
import { Navigate } from '@tanstack/react-router';
import { useAuth } from './AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredPermission?: string;
  requiredRole?: string;
}

export function ProtectedRoute({
  children,
  requiredPermission,
  requiredRole,
}: ProtectedRouteProps): JSX.Element {
  const {
    isAuthenticated,
    isLoading,
    hasPermission,
    hasRole,
  } = useAuth();

  // Check permission
  if (!isLoading && isAuthenticated && requiredPermission) {
    if (!hasPermission(requiredPermission)) {
      return (
        <div
          role="alert"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '50vh',
            color: '#ba1a1a',
          }}
        >
          <h2>Acesso negado</h2>
          <p>Você nao tem permissao para acessar esta pagina.</p>
        </div>
      );
    }
  }

  // Check role
  if (!isLoading && isAuthenticated && requiredRole) {
    if (!hasRole(requiredRole)) {
      return (
        <div
          role="alert"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '50vh',
            color: '#ba1a1a',
          }}
        >
          <h2>Acesso negado</h2>
          <p>Você nao tem o nivel de acesso necessario.</p>
        </div>
      );
    }
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <div
          aria-label="Carregando"
          role="status"
          style={{
            width: 40,
            height: 40,
            border: '4px solid #e0e3e5',
            borderTopColor: '#002045',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
          }}
        />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
